
import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const RecoveryPw = ({ dispatch_post_password_code }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const [code, set_code] = useState("");

  useEffect(() => {}, []);
  return (
    <div class="d-flex flex-column justify-content-between bg-light vh-100">
      <header className="py-3 mb-auto bg-brand">
        <div className="container d-flex justify-content-between align-items-center">
          <a
            className="text-white"
            href="javascript:history.back();"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();

              window.scroll(0, 0);
            }}
          >
            <i className="fas fa-angle-left fa-fw" />
            {t("戻る")}
          </a>
          <a
            href="index.html"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
              window.scroll(0, 0);
            }}
          >
            <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
          </a>
        </div>
      </header>
      <main role="main" className="main">
        <div className="container">
          <section className="login-section mx-auto mb-4">
            <div className="card">
              <div className="card-body">
                <form action="recovery-pw-verify.html" method="post">
                  <h1 className="h4 text-center font-weight-bold mb-4">
                    {t("コード認証")}
                  </h1>
                  <div className="form-group">
                    <label htmlFor="ml">{t("コード")}</label>
                    <input
                      type="code"
                      id="ml"
                      className="form-control"
                      placeholder="123456"
                      required
                      value={code}
                      onChange={(e) => {
                        set_code(e.target.value);
                      }}
                    />
                    <small className="form-text text-muted">
                      {t("送信されたコードを入力してください")}
                    </small>
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-gradient-primary btn-block"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch_post_password_code({ code }, () => {
                          history.push({
                            pathname: `/initialize-pw`,
                          });
                          window.scroll(0, 0);
                        });
                      }}
                    >
                      {t("パスワードをリセット")}
                    </button>
                  </div>
                  <hr />
                  <a
                    className="btn btn-outline-secondary btn-block"
                    href="signin.html"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/signin`,
                      });
                      window.scroll(0, 0);
                    }}
                  >
                      {t("ログイン")}
                  </a>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footer className="mt-auto" />
    </div>
  );
};

export default RecoveryPw;
